import { useCallback } from 'react';
import { stringRequired } from '../../utils/validations';
import { AddCommentToWorkItemErrorsType, AddCommentToWorkItemActionType, AddCommentInputDataType } from '../types';

export const initialAddCommentToWorkItem: AddCommentToWorkItemActionType = {
	relationship: 'this-work-item',
	commentValue: '',
};

export function useAddCommentToWorkItem() {
	const validate = useCallback((
		values: {
				commentValue: string;
      }): {
        hasErrors: () => boolean;
        errors: AddCommentToWorkItemErrorsType;
      } => {
		let hasErrors = false;
		const validations = {
			commentValue: [
				stringRequired(values.commentValue, 'This field is required'),
			],
		};
    
		const getError = (validation: Array<string | undefined>) => {
			const foundError = validation.find(item => item !== undefined) || null;
			if (foundError) {
				hasErrors = true;
			}
    
			return foundError || null;
		};

		return {
			hasErrors: () => hasErrors,
			errors: {
				commentValue: getError(validations.commentValue),
			}
		};
	}, []);

	const getValues = useCallback((data: AddCommentToWorkItemActionType) => {	
		return {
			value: data.commentValue,
			relationship: data.relationship,
		};
	}, []);

	const loadValues = useCallback((input: AddCommentInputDataType): AddCommentToWorkItemActionType => {
		return {
			commentValue: input.value,
			relationship: input.relationship,
		};
	}, []);

	return {
		validate,
		getValues,
		loadValues
	};
}